export type DayOfWeek = '0' | '1' | '2' | '3' | '4' | '5' | '6';
export type DayOfWeekNumber = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export interface CalendarSettingsModel {
    weekStartsOn: DayOfWeek;
    weekendDays: DayOfWeek[];
}

export const DEFAULT_WEEK_STARTS_ON: DayOfWeek = '1';
export const DEFAULT_WEEKEND_DAYS: DayOfWeek[] = ['0', '6'];

export const mapDayOfWeekToNumber = (dayOfWeek: DayOfWeek): DayOfWeekNumber => Number(dayOfWeek) as DayOfWeekNumber;

export const mapDayOfWeekListToNumbers = (daysOfWeek: DayOfWeek[] = []): DayOfWeekNumber[] => {
    return daysOfWeek.map(mapDayOfWeekToNumber);
};
